var generator = null;

// _genUUIDImpl :: Effect String
exports._genUUIDImpl = function () {
  if (generator === null) generator = require('uuid').v4;
  return generator();
};

const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

exports.isValidUUID = (str) => !!uuidRegex.exec(str);
